import { HeidiLogoMark } from '@heidi/design-system/heidi-logo-mark';
import { TypographyCaption, TypographyP2 } from '@heidi/design-system/typography';
import { dictationIntlMessages } from '@heidi/dictate';
import { type ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';

export interface DictationListeningContentProps {
  /** Volume bars slot — audio visualisation + optional stop button (differs per environment). */
  volumeBars?: ReactNode;
  /** Optional subtitle, e.g. hands-free label. */
  subtitle?: ReactNode;
}

export const DictationListeningContent = ({
  volumeBars,
  subtitle,
}: DictationListeningContentProps) => {
  return (
    <>
      <HeidiLogoMark aria-label="Heidi" className="size-5" />
      <div className="flex flex-1 flex-col">
        <TypographyP2 className="text-text-primary">
          <FormattedMessage {...dictationIntlMessages.dictating} />
        </TypographyP2>
        {subtitle && (
          <TypographyCaption className="text-text-secondary">
            {subtitle}
          </TypographyCaption>
        )}
      </div>
      {volumeBars}
    </>
  );
};
